import { Component } from "@angular/core";
import { ViewService } from "./view.service";

@Component({
  selector: "close-button",
  template: `<button title="Close" class="btn btn-outline-secondary pull-right" (click)="onClick()">
    <mat-icon>close</mat-icon>
  </button>`,
  standalone: false,
})
export class BackButtonDirective {
  constructor(private viewService: ViewService) {}

  onClick(): void {
    this.viewService.back();
  }
}
